import { useTranslation } from 'react-i18next'
import { Card } from '#app/ui/components/custom/card'
import { Section } from '#app/ui/components/custom/section'
import { SectionHeader } from '#app/ui/components/custom/section-header'

type Symptom = { title: string; body: string }

export const Problem = () => {
	const { t } = useTranslation('home')
	const symptoms = t('problem.symptoms', {
		returnObjects: true,
	}) as Symptom[]

	return (
		<Section tone="panel">
			<SectionHeader
				eyebrow={t('problem.eyebrow')}
				heading={t('problem.heading')}
				lead={t('problem.lead')}
			/>
			<div className="mt-fluid-16 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
				{symptoms.map(symptom => (
					<Card key={symptom.title} title={symptom.title} body={symptom.body} />
				))}
			</div>
		</Section>
	)
}
